import { render } from "./Login.vue?vue&type=template&id=f04e5ad2&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=f04e5ad2&scoped=true&lang=css"

import exportComponent from "E:\\code\\my\\bookmark.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f04e5ad2"]])

export default __exports__